import { render, staticRenderFns } from "./DescansoMedicoEditarAtencion.vue?vue&type=template&id=572b066c"
import script from "./DescansoMedicoEditarAtencion.vue?vue&type=script&lang=js"
export * from "./DescansoMedicoEditarAtencion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports